import axios from 'axios'
import router from '../router'
import config from '../config'

const axiosInstance = axios.create({
  baseURL: config.api_url,
  json: true
})

/*
request

axiosInstance.interceptors.request.use((config) => {
  // const token = localStorage.getItem('access_token')
  const token = cookie.get('access_token')

  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
}, (err) => {
  return Promise.reject(err)
})
*/

/*
response
*/
axiosInstance.interceptors.response.use((response) => {
  // if (response && !response.data) {
  //   router.push('/error')
  // }
  return response
}, (err) => {
  console.log(err.response)

  // if (err.response && err.response.status === 401) {
  //   router.push('/error')
  // }

  return Promise.reject(err)
})

export default axiosInstance
